export default "__VITE_ASSET__C2D9zSOf__"